import React from 'react';
import ReactDOM from 'react-dom';
import App from '@elevio/kb-kit/lib/App';
import config from './config';
import './css/main.css';
const target = document.getElementById('kb-target');
if (!target)
    throw new Error('Cant find target div');
if (!document.title.trim()) {
    document.title = 'Mill Creek Maintenance Portal';
}
target.setAttribute('role', 'main');
target.setAttribute('aria-label', 'Loading content');
ReactDOM.render(<App config={config}/>, target, () => {
    target.removeAttribute('role');
    target.removeAttribute('aria-label');
    if (process.env.NODE_ENV !== 'production') {
        import('@axe-core/react').then((axe) => {
            axe.default(React, ReactDOM, 1000);
        });
    }
});
